import { ConsoleLogger } from './ConsoleLogger';

export type { Logger } from './Logger';
export type { LogMethod } from './logHelpers';

export const logger = new ConsoleLogger();

export const initLogger = async () => {
    await logger.initialize();
};
